import URL from 'url-parse';

import computed from 'lib/mobx/computed';
import {Link} from 'lib/ui/link';

export class ThreadLink extends Link {
    @computed get replyCount() {
        return this.thread.replyCount;
    }

    constructor(options) {
        const {thread, params = {}} = options;
        const url = new URL(thread.href, ' ');
        url.set('query', params);

        super({
            label: () => thread.title[0].toUpperCase() + thread.title.substr(1),
            href: url.href,
        });

        this.thread = thread;
    }
}
